import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import AccountHistory from '../../accountHistory/AccountHistory';
import ApplyFlexiLoanView from '../../applyFlexiLoanView/ApplyFlexiLoanView';
import { CBILSDashboard } from '../../CBILS/dashboard/Dashboard';
import Dashboard from '../../dashboard/';
import EarlyRepayment from '../../earlyRepayment/EarlyRepayment';
import PageNotFound from '../../pageNotFound/PageNotFound';
import MainContentPending from '../mainContentPending/MainContentPending';
import TradingData from '../../tradingData/TradingData';
import Profile from '../../Profile/';
import SecondCBILSDashboard from '../../CBILS/secondCBILSDashboard/SecondCBILSDashboard';
import IwocapayDashboard from '../../iwocaPay/dashboard/Dashboard';
import { useStateKey } from '../../../iwQueryClient/useStateKey';
import { trackPageView } from '../../../tracking/pageView';
import RLSDashboard from '../../RLS/dashboard/Dashboard';
import RBLDashboard from '../../revenueBasedLoan/dashboard/Dashboard';
import { FLEXI_24_PAGE_NAME } from '../../flexi24/dashboard.saga';
import { TERM_LOAN_PAGE_NAME } from '../../termLoan/Dashboard.sagas';
import { FLEXI_12_PAGE_NAME } from '../../dashboard/Dashboard.sagas';
import MyOffers from '../../myOffers/MyOffers';
import FundingRequirementsView from '../../funding/fundingRequirementsView/FundingReqirementsView';
import ConfirmFundingView from '../../funding/ConfirmFundingView/ConfirmFundingView';
import { useEffect } from 'react';
import { Contracts } from '../../contracts/contracts';
import { SellerDirecotry } from '../../iwocaPay/sellerDirectory/sellerDirectory';

const mapStateToProps = ({ mainContent }) => ({
    ...mainContent
});

const MainContent = ({ activePage }) => {
    const stateKey = useStateKey();

    useEffect(() => {
        const pagesToLog = {
            [FLEXI_12_PAGE_NAME]: 'Flexi-12 Dashboard',
            [FLEXI_24_PAGE_NAME]: 'Flexi-24 Dashboard',
            [TERM_LOAN_PAGE_NAME]: 'Term Loan Dashboard',
            SECOND_CBILS_DASHBOARD: 'Second CBILS Dashboard',
            RLS_DASHBOARD: 'RLS Dashboard',
            RBL_DASHBOARD: 'RBL Dashboard'
        };

        if (Object.keys(pagesToLog).includes(activePage)) {
            trackPageView(stateKey, pagesToLog[activePage]);
        }
    }, [stateKey, activePage]);

    switch (activePage) {
        case FLEXI_12_PAGE_NAME:
            return <Dashboard />;
        case FLEXI_24_PAGE_NAME:
            return (
                <div data-testid="flexi24-content">
                    <Dashboard />
                </div>
            );
        case TERM_LOAN_PAGE_NAME:
            return (
                <div data-testid="term-loan-content">
                    <Dashboard />
                </div>
            );
        case 'CBILS_DASHBOARD':
            return (
                <div data-testid="cbils-loan-content">
                    <CBILSDashboard />
                </div>
            );
        case 'SECOND_CBILS_DASHBOARD':
            return (
                <div data-testid="second-cbils-loan-content">
                    <SecondCBILSDashboard />
                </div>
            );
        case 'RLS_DASHBOARD':
            return (
                <div data-testid="rls-content">
                    <RLSDashboard />
                </div>
            );
        case 'RBL_DASHBOARD':
            return (
                <div data-testid="rbl-content">
                    <RBLDashboard />;
                </div>
            );
        case 'TRADING_DATA':
            return <TradingData />;
        case 'PROFILE':
            return <Profile />;
        case 'EARLY_REPAYMENT':
            return <EarlyRepayment />;
        case 'PAGE_NOT_FOUND':
            return <PageNotFound />;

        default:
            return (
                <Switch>
                    <Route path="/apply-flexi-loan/">
                        <ApplyFlexiLoanView />
                    </Route>
                    <Route path="/my-offers/">
                        <MyOffers />
                    </Route>
                    <Route path="/funding-requirements/">
                        <FundingRequirementsView />
                    </Route>
                    <Route path="/CBILS/">
                        <CBILSDashboard />
                    </Route>
                    <Route path="/confirm-funding/">
                        <ConfirmFundingView />
                    </Route>
                    <Route path="/iwocapay/directory/">
                        <SellerDirecotry />
                    </Route>
                    <Route path="/iwocapay/">
                        <div data-testid="iwocapay-content">
                            <IwocapayDashboard />
                        </div>
                    </Route>
                    <Route path="/contracts/">
                        <Contracts />
                    </Route>
                    <Route>
                        <AccountHistory path="/history/" />
                    </Route>
                    <Route>
                        <MainContentPending />
                    </Route>
                </Switch>
            );
    }
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(MainContent);
